var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMystery = function SvgMystery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 12 229.652 253.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mystery_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10039"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "mystery_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.044 223.006a81.6 81.6 0 0 1-16.318-1.645 80.6 80.6 0 0 1-15.197-4.717 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377 4.563-11.342 10.982-22.675 18.564-32.775 3.966-5.283 8.198-10.15 12.577-14.469 4.607-4.542 9.382-8.478 14.192-11.697 5.09-3.406 10.26-6.036 15.368-7.816 5.414-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.383 16.889 12.653 12.652 22.267 23.309 29.393 32.58 3.541 4.607 6.481 8.872 8.988 13.039 2.423 4.029 4.38 7.866 5.983 11.73 6.246 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.299-7.742 3.135-17.116 5.272-28.657 6.534-9.037.988-19.514 1.448-32.972 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff725e",
    d: "M112.816 42.562c-5.217 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.254 7.76-4.784 3.201-9.534 7.117-14.12 11.637-4.36 4.3-8.576 9.15-12.527 14.414-7.556 10.065-13.954 21.359-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.916 1.635 16.217a80 80 0 0 0 4.688 15.103 80.5 80.5 0 0 0 7.418 13.668 81 81 0 0 0 9.827 11.91 81 81 0 0 0 11.909 9.826 80.5 80.5 0 0 0 13.668 7.418 80 80 0 0 0 15.103 4.688 81 81 0 0 0 16.217 1.635c13.439 0 23.899-.46 32.918-1.445 11.494-1.257 20.824-3.383 28.523-6.5 4.256-1.723 8.052-3.783 11.283-6.123 3.416-2.474 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.423 1.976-9.393 1.976-14.773 0-3.66.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.656-5.95-11.664-2.496-4.15-5.426-8.4-8.956-12.992-7.112-9.253-16.712-19.894-29.35-32.53-11.108-11.11-23.23-16.743-36.03-16.743m0-1c12.207 0 24.705 5.002 36.738 17.035 55.473 55.474 50.38 70.135 50.38 115.128s-44.897 49.781-89.889 49.781-81.465-36.473-81.465-81.465c0-35.233 40.173-100.479 84.237-100.479"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#mystery_svg__a)",
    transform: "translate(8.189 33.483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#ef4444",
    d: "M98.223 104.245c-10-15 10-25 25-15 15-15 40 0 30 20 20 5 10 35-10 35-5 20-35 20-40 0-20-5-25-30-5-40",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#c53030",
    d: "M113.223 99.245q10 10 0 20M133.223 99.245q-10 15 5 25",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.223,
    cy: 164.245,
    r: 6,
    fill: "#1f2937",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b82f6",
    d: "M78.223 170.245h10v20h-10z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f2937",
    d: "M73.223 190.245h6v18h-6zM86.223 190.245h6v18h-6z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.223,
    cy: 179.245,
    r: 6,
    fill: "#1f2937",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef4444",
    d: "M123.223 184.245h10v22h-10z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f2937",
    d: "M118.223 204.245h6v18h-6zM133.223 204.245h6v18h-6z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.223,
    cy: 169.245,
    r: 6,
    fill: "#1f2937",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9ca3af",
    d: "M173.223 174.245h10v24h-10z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f2937",
    d: "M168.223 198.245h6v18h-6zM182.223 198.245h6v18h-6z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.223,
    cy: 159.245,
    r: 12,
    fill: "none",
    stroke: "#1f2937",
    strokeWidth: 2,
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1f2937",
    strokeWidth: 2,
    d: "m168.223 169.245 10 10",
    style: {
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 30,
    x: 78.223,
    y: 79.245,
    fill: "#e5e7eb",
    rx: 6,
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.223,
    cy: 94.245,
    r: 6,
    fill: "#ef4444",
    style: {
      strokeWidth: 1
    }
  }));
};
export default SvgMystery;